import { useMemo } from 'react';

import { ServiceMode } from 'generated/graphql-gateway';
import { useServiceModeContext } from 'state/service-mode';

import { getPosServiceMode } from './utils';

export function useMenuQueryOptions() {
  const { serviceMode } = useServiceModeContext();

  const value = useMemo(
    () => ({
      posServiceMode: getPosServiceMode(serviceMode ?? ServiceMode.DRIVE_THRU),
    }),
    [serviceMode]
  );
  return value;
}
